var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.44287 10.902V23.6749H23.4771V10.902M1.44287 10.902V3.80586H23.4771V10.902M1.44287 10.902H12.46M23.4771 10.902H12.46M12.46 10.902V15.1596M23.4771 15.1596H17.9685M17.9685 15.1596H12.46M17.9685 15.1596V10.902M17.9685 15.1596V19.4173M12.46 15.1596H6.95143M12.46 15.1596V19.4173M6.95143 15.1596H1.44287M6.95143 15.1596V10.902M6.95143 15.1596V19.4173M23.4771 19.4173H17.9685M17.9685 19.4173H12.46M17.9685 19.4173V23.6749M12.46 19.4173H6.95143M12.46 19.4173V23.6749M6.95143 19.4173H1.44287M6.95143 19.4173V23.6749M19.3457 7.35391V0.257812M5.57429 7.35391V0.257812",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.da7d5c2f34b61adbad06aab3e9ff7c27.svg";
export { ForwardRef as ReactComponent };